
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { JiraLinkedService } from 'app/model/linkedservice/jira.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'JiraObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Jira_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Jira_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: JiraLinkedService.MODEL // Linked service redefined
        }
    }
})
export class JiraObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
